import {makeStyles} from "@material-ui/core"

export default makeStyles(() => ({
    wrap: {
        width: "100%",
        maxWidth: 1280,
        margin: "0 auto",
        padding: "22px 22px 40px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        flex: "1 1 auto",

        "@media (max-width:640px)": {padding: "16px 12px 28px"},
    },
}))
